module.exports = __webpack_public_path__ + "media/images/choose/payout_author-3a1bc23aa2bedfd2069c047c655616bb.png";